<template>
    <div>
        <div class="mainNav">
            <div id="download">
                <el-button type="success" size="small" @click="download(tableData.source_doc_id)">下载文件</el-button>
                <el-button type="success" size="small" @click="saveall()">一键保存</el-button>
                <el-button type="success" size="small" @click="again()">再来一篇>></el-button>
            </div>
        </div>
        <div class="main">
            <el-table ref="table"
                    :data="tableLoop"
                    border
                    style="width: 100%"
                    id="our_table">
                <el-table-column label="序号" type="index" :index="indexMethod"  align="center" width="60">
                </el-table-column>

                <el-table-column label="原文栏">
                    <template slot-scope="scope">
                        <div style="outline: none" contenteditable="true" v-html="tableData.source[scope.$index].source_p"  @blur="edit(scope.$index, scope.row, 'source', $event.target.innerText)">
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="状态" width="60">
                </el-table-column>

                <el-table-column label="译文栏">
                    <template slot-scope="scope">
                        <div class="editorBox" v-if="scope.$index<tLength">
                            <div style="outline: none" contenteditable="true" v-html="tableData.translate[scope.$index].translate_p"  @blur.stop="edit(scope.$index, scope.row, 'translate', $event.target.innerText)">
                            </div>
                        </div>
                        <span class="move"
                              v-if="tableData.translate[scope.$index].translate_p[0] && scope.$index < tLength">
                                    <el-button round v-show="!tableData.translate[scope.$index].translate_p[0].insert"
                                               @click="up(scope.$index)" v-if="scope.$index - 1 >= 0" size="mini">UP</el-button>
                                    <el-button round v-show="!tableData.translate[scope.$index].translate_p[0].insert"
                                               @click="down(scope.$index)" v-if="scope.$index - tLength != -1"
                                               size="mini">Down</el-button>
                                    <el-button round v-show="tableData.translate[scope.$index].is_para"
                                               @click="insert(scope.$index)" size="mini">insert</el-button>
                                    <el-button round @click="del(scope.$index)" size="mini">delete</el-button>
                                </span>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.$index < tLength"
                                   size="mini" type="success" plain
                                   @click="save(scope.$index, scope.row)">保存
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'detail',
        data() {
            return {
                tableData: {},
                t_data_length: '',
                count: '',
                tableLoop: [],
                tableLoopStatus: 0,
                tLength: '',
                sLength: '',
                limit:50,
                offset:0,
                loading: true,
                dom: ''
            }
        },
        methods: {
            indexMethod(index) {
                return index + 1;
            },
            again(){
                this.$router.push("/")
            },
            down(index) {
                // 第一行的
                let y_p = this.tableData.translate[index].translate_p;
                let y_p_id = this.tableData.translate[index].uniqueid;
                // 第二行
                let m_p = this.tableData.translate[index + 1].translate_p;
                let m_p_id = this.tableData.translate[index + 1].uniqueid;
                let y_c = this.check_table(y_p);
                let m_c = this.check_table(m_p);
                try {
                    let read = JSON.parse(localStorage.getItem('read'));
                    let row = read[index + 2];
                    if (row != undefined) {
                        // console.log(row, index+2)
                        var dm_p = {}
                        for (let key in row) {
                            dm_p['insert'] = 1;
                            dm_p['is_para'] = row[key].is_para;
                            dm_p['r_id'] = key;
                            dm_p['run'] = row[key].query;
                        }
                        var m = [dm_p]
                        // 把上一行状态改为保存完成并清除local
                        let statuss = $("tr:eq(" + (index + 2) + ")").children().eq(2);
                        statuss.html("");

                        let status = $("tr:eq(" + (index + 1) + ")").children().eq(2);
                        status.html("<i id='save_status' class='el-icon-success'></i>");
                        delete (read[index + 2]);
                        localStorage.setItem('read', JSON.stringify(read));
                    } else {
                        var m = this.tableData.translate[index + 1].translate_p;
                        // console.log(m, '//*-*/-*-*-*')
                    }
                } catch {
                    var m = this.tableData.translate[index + 1].translate_p;
                    console.log(m)
                    // console.log(m, '//*-*/-*-*-*')
                }
                // console.log(m, y_p, index)/
                if (y_c && m_c) {
                    // 第二行的内容给第一行
                    this.tableData.translate[index].translate_p = m;
                    this.tableData.translate[index + 1].translate_p = y_p;
                    this.save_move(y_p_id, y_p, m_p_id, m)
                } else {
                    this.$message("暂不支持包含表格内容的移动")
                }
                // TODO: 判断两行中有没有包含一个是表格的  如包含一个 此操作无效
            },
            up(index) {
                // 第一行的
                let y_p = this.tableData.translate[index].translate_p;
                let y_p_id = this.tableData.translate[index].uniqueid;
                // 第0行
                // 先从loacal获取，没有值再获取data
                // alert(index)
                try {
                    let read = JSON.parse(localStorage.getItem('read'));
                    let row = read[index];
                    if (row != undefined) {
                        // console.log(row, index)
                        var m_p = {}
                        for (let key in row) {
                            m_p['insert'] = 1;
                            m_p['is_para'] = row[key].is_para;
                            m_p['r_id'] = key;
                            m_p['run'] = row[key].query;
                        }
                        var m = [m_p]
                        // 把上一行状态改为保存完成并清除local
                        let statuss = $("tr:eq(" + (index) + ")").children().eq(2);
                        statuss.html("");

                        let status = $("tr:eq(" + (index + 1) + ")").children().eq(2);
                        status.html("<i id='save_status' class='el-icon-success'></i>");
                        delete (read[index]);
                        localStorage.setItem('read', JSON.stringify(read));
                    } else {
                        var m = this.tableData.translate[index - 1].translate_p;
                    }
                } catch {
                    var m = this.tableData.translate[index - 1].translate_p;
                    console.log(m)
                }
                let m_p_id = this.tableData.translate[index - 1].uniqueid;
                // console.log('y_p:' + y_p, 'm_p:' + m_p)
                let y_c = this.check_table(y_p);
                let m_c = this.check_table(m);
                // console.log(y_c, m_c)
                if (y_c && m_c) {
                    // 第yi行的内容给第0行
                    this.tableData.translate[index].translate_p = m;
                    // this.tableData.content[index].translate_p_id = m_p_id;
                    this.tableData.translate[index - 1].translate_p = y_p;
                    // this.tableData.content[index-1].translate_p_id = y_p_id;
                    // console.log(y_p_id, y_p)
                    // console.log(m_p_id, m_p)
                    this.save_move(y_p_id, y_p, m_p_id, m)
                } else {
                    this.$message("暂不支持包含表格内容的移动")
                }

            },
            insert(index) {
                let max = this.tableData.translate[index].uniqueid;       // 点击插入行
                if (max <= 1) {
                    var min = 0.1;
                } else {
                    var min = this.tableData.translate[index - 1].uniqueid;     // 点击插入上行
                }
                let uniqueid = Number(this.random(min, max).toString().match(/^\d+(?:\.\d{0,6})?/))

                // 保存插入行
                let param = new FormData();
                let data = {
                    'insert':
                        {
                            "paragraph_id": 'insert',
                            'doc_id': this.tableData.translate_doc_id,
                            'uniqueid': uniqueid,
                            'query': '',
                            is_para: 1,
                            insert: 1
                        }
                }
                // param.append("row_data", JSON.stringify(data));
                param.append("paragraph_id", 'insert');
                param.append("doc_id", this.tableData.translate_doc_id);
                param.append("uniqueid", uniqueid);
                param.append("query", '');
                param.append("is_para", 1);
                var _this = this;
                _this.$axios.post('/merge/correct/', param)
                    .then(function (response) {
                        if(response.data.code == 0){
                            _this.tableData.translate.splice(index, 0,
                                {
                                    translate_p_id: 'insert',
                                    uniqueid: uniqueid,
                                    o_value: 0.000003,
                                    translate_p: '',
                                    // translate_p: [{run: '', r_id: response.data.r_id, is_para: 1, insert: 1,},],
                                }
                            );
                            _this.tLength += 1;
                            let smin = _this.tableData.source[_this.tableData.source.length - 1].uniqueid;       // 点击插入行
                            console.log(smin)
                            let smax = smin + 1;
                            console.log(smax)
                            let suniqueid = Number(_this.random(smin, smax).toString().match(/^\d+(?:\.\d{0,6})?/))
                            if (_this.tLength >= _this.sLength) {
                                _this.tableData.source.push({
                                    source_p_id: 'insert',
                                    source_p: '',
                                    uniqueid: suniqueid,
                                    // source_p: [{run: '', run_id: 'insert', is_para: 1,},],
                                })
                            }
                        }
                    })
                // .catch(function (error) {
                //     window.console.log(error)
                // })
            },
            random(start, stop) {
                return Math.random() * (stop - start) + start;
            },
            RandomNum(Min, Max) {
                var Range = Max - Min;
                var Rand = Math.random();
                if (Math.round(Rand * Range) == 0) {
                    return Min + 1;
                } else if (Math.round(Rand * Max) == Max) {
                    // index++;
                    return Max - 1;
                } else {
                    var num = Min + Math.round(Rand * Range) - 1;
                    return num;
                }
            },

            del(index) {
                let on_uniqueid = this.tableData.translate[index].uniqueid;
                let doc_id = this.tableData.translate_doc_id;

                this.tableData.translate.splice(index, 1);
                this.tableData.translate.push({translate_p: [{run: '', is_para: 1,},]});
                let endTrans = this.tableData.translate[this.tableData.translate.length - 1].translate_p[0].run;
                let endSource = this.tableData.source[this.tableData.source.length - 1].source_p[0].run;
                // console.log(endTrans);
                // console.log(endSource);
                if (endTrans == endSource) {
                    this.tableData.translate.splice(this.tableData.translate.length - 1, 1);
                    this.tableData.source.splice(this.tableData.source.length - 1, 1);
                }
                // else{
                //     this.tableData.translate.splice(index,0, {translate_p_id:4,translate_p:[{run: '',run_id: 12,is_para: 1,},],});
                // }
                // console.log(this.tableData.translate)
                this.tLength -= 1;

                let param = new FormData();
                param.append('uniqueid', on_uniqueid);
                param.append('doc_id', doc_id);
                var _this = this;
                _this.$axios.post('/merge/delete_para/', param)
                    .then(function (response) {
                        window.console.log(response)
                    })
                    .catch(function (error) {
                        window.console.log(error)
                    })
            },
            // startEdit(e){
            //     var el = event.target.children;
            //     el[0].style.minWidth='50px';
            //     el[0].style.display='inline-block';
            //     window.console.log(el[0].style.width)
            // },
            save_move(y_p_id, y_p, m_p_id, m_p) {
                let param = new FormData();
                // on_id 修改后点击行的段落ID
                // next_id 修改后 点击行的 上一ID或 下一ID
                param.append('on_id', m_p_id);
                param.append('on', y_p);
                param.append('next_id', y_p_id);
                param.append('next', m_p);
                param.append('doc_id', this.tableData.translate_doc_id);
                var _this = this;
                _this.$axios.post('/merge/movepara/', param)
                    .then(function (response) {
                        // console.log(response)
                    })
            },
            check_table(arr) {
                var i = 0;
                while (i < arr.length) {
                    if (arr[i].is_para == 0) {
                        return false
                    }
                    i++;
                }
                return true
            },
            /* 在文本框中编辑失焦后的方法， 存储修改后的内容到localStorage， 以便于点击保存按钮后的提交
            *  需要传递的参数：
                * paragraph_id : 当前段落id
                * doc_id : 原文或译文的文档id
                * is_para : 是段落还是表格
                * query : 修改后的内容
                * uniqueid : 段落的唯一标识
            */
            edit(index, row, pType, query){
                let pIdKey;                 // 译文或原文 段落id的键
                pIdKey = pType === 'translate' ? pType+'_id' : pType+"_p_id";
                let docIdKey;               // 译文或原文 文档id的键
                docIdKey = pType === 'translate' ? pType+'_doc_id' : pType+"_doc_id";
                let paragraph_id = this.tableData[pType][index][pIdKey];        // 段落id
                let doc_id = this.tableData[docIdKey];                          // 文档id
                let is_para = this.tableData[pType][index].is_para;             // 是否段落
                let uniqueid = this.tableData[pType][index].uniqueid;           // 唯一值
                if(query != this.tableData[pType][index][pType+'_p']){          // 当修改内容后，状态栏出现编辑小图标
                    let status = $("tr:eq(" + (index+1) + ")").children().eq(2);
                    status.html("<i id='edit_status' class='el-icon-edit'></i>");
                }
                let read = JSON.parse(localStorage.getItem('read'));
                if(read === null){  // 还没存储过
                    let read = {};
                    let row = read[index] = {};
                    row[index] = {
                        'paragraph_id': paragraph_id,
                        'doc_id': doc_id,
                        'is_para': is_para,
                        'query': query,
                        'uniqueid': uniqueid
                    };
                    localStorage.setItem('read', JSON.stringify(read));
                }else {
                    let row_data = read[index];
                    if(row_data === undefined){     // 当前这行还没存储过
                        let row = read[index] = {};     // 新增这行
                        row[index] = {
                            'paragraph_id': paragraph_id,
                            'doc_id': doc_id,
                            'is_para': is_para,
                            'query': query,
                            'uniqueid': uniqueid
                        };
                        localStorage.setItem('read', JSON.stringify(read));
                    }else{          // 当前行存储过了
                        row_data.paragraph_id = paragraph_id;
                        row_data.doc_id = doc_id;
                        row_data.is_para = is_para;
                        row_data.query = query;
                        row_data.uniqueid = uniqueid;
                        localStorage.setItem('read', JSON.stringify(read));
                    }
                }
            },
            submit(row_id) {
                // 获取到是第几行后， 查找loaca里面 read[row_is] 把这个对象 传给后端
                let read = JSON.parse(localStorage.getItem('read'));
                if (read != null && read[row_id] != undefined) {
                    let rowData = read[row_id][row_id];
                    let param = new FormData();
                    param.append("paragraph_id", rowData.paragraph_id);
                    param.append("doc_id", rowData.doc_id);
                    param.append("is_para", rowData.is_para);
                    param.append("query", rowData.query);
                    param.append("uniqueid", rowData.uniqueid);
                    var _this = this;
                    _this.$axios.post('/merge/correct/', param)
                        .then(function (response) {
                            if(response.data.code === 0){
                                _this.$notify({
                                    title: '保存成功',
                                    message: '第' + (row_id+1) + '行 保存成功!!',
                                    type: 'success',
                                    duration: 1000,
                                });
                                // 通过key删除value
                                // 保存剩下的到local
                                delete (read[row_id]);
                                localStorage.setItem('read', JSON.stringify(read));
                                let status = $("tr:eq(" + (row_id+1) + ")").children().eq(2);
                                status.html("<i id='save_status' class='el-icon-success'></i>");
                            }else {
                                _this.$notify({
                                    title: '保存失败',
                                    message: '第' + (row_id+1) + '行 保存失败!!',
                                    type: 'error',
                                    duration: 800,
                                });
                            }
                        })
                } else {
                    this.$message({
                        message: '第' + (row_id+1) + '行未做修改! ~ ',
                        duration: 800,
                    });
                }
            },

            save(index, row) {
                // console.log(index, row);
                // var row_id = parseInt(index) + 1;
                this.submit(index);
            },

            run_msg(value, id, is_para, row_id) {
                // console.log(value, id, is_para, row_id, index);
                // 获取这一行的状态
                let status = $("tr:eq(" + row_id + ")").children().eq(2);
                status.html("<i id='edit_status' class='el-icon-edit'></i>");
                try {
                    // 获取段落
                    try {
                        // 获取原文 内容
                        var query = $("#sp" + id)[0].textContent.replace(/(^\s*)|(\s*$)/g, "");
                        var doc_id = this.tableData.source_doc_id
                    } catch (err) {
                        // 获取译文内容
                        var query = $("#tp" + id)[0].textContent.replace(/(^\s*)|(\s*$)/g, "");
                        var doc_id = this.tableData.translate_doc_id
                    }
                } catch (err) {
                    // 获取表格
                    try {
                        // 获取原文 内容
                        var query = $("#st" + id)[0].textContent.replace(/(^\s*)|(\s*$)/g, "");
                        var doc_id = this.tableData.source_doc_id
                    } catch (err) {
                        // 获取译文内容
                        var query = $("#tt" + id)[0].textContent.replace(/(^\s*)|(\s*$)/g, "");
                        var doc_id = this.tableData.translate_doc_id
                    }
                }
                // console.log(query, doc_id, row_id)
                // value : 段ID
                // id: 句子 ID
                // is_para:  是段落还是表格
                // query:  内容
                // doc_id: 文档ID
                // row_id: 哪一行的ID
                // 存储到 locastrange
                // 1.获取当前行id 在loca里面不
                // 当前行 没存过
                let read = JSON.parse(localStorage.getItem('read'));
                // console.log(read)
                if (read == null) {
                    // 一次还没存
                    // console.log('一次还没存')
                    let read = {}
                    let row = read[row_id] = {}
                    row[id] = {
                        'paragraph_id': value,
                        'sentence_id': id,
                        'doc_id': doc_id,
                        'is_para': is_para,
                        'query': query
                    };
                    localStorage.setItem('read', JSON.stringify(read));
                } else {
                    // 有存过了
                    // console.log('有存过了')
                    // 获取当前行是否有存过
                    let row_data = read[row_id];
                    // console.log(row_data)
                    if (row_data == undefined) {
                        // 当前行 还没存过
                        // console.log('当前行 还没存过')
                        let row = read[row_id] = {}
                        row[id] = {
                            'paragraph_id': value,
                            'sentence_id': id,
                            'doc_id': doc_id,
                            'is_para': is_para,
                            'query': query
                        };
                        localStorage.setItem('read', JSON.stringify(read));
                    } else {
                        // 当前行 存过了
                        // console.log('当前行 存过')
                        // 获取这个句子是否存过
                        let juzi = row_data[id];
                        // console.log(id, '句子ID')
                        // console.log(juzi)
                        if (juzi == undefined) {
                            // console.log('这个句子没存过')
                            // 存 这
                            row_data[id] = {
                                'paragraph_id': value,
                                'sentence_id': id,
                                'doc_id': doc_id,
                                'is_para': is_para,
                                'query': query
                            }
                            localStorage.setItem('read', JSON.stringify(read));
                        } else {
                            // console.log("这个句子存过")
                            row_data[id] = {
                                'paragraph_id': value,
                                'sentence_id': id,
                                'doc_id': doc_id,
                                'is_para': is_para,
                                'query': query
                            }
                            localStorage.setItem('read', JSON.stringify(read));
                        }
                    }
                }
            },
            download(doc_id) {
                // 获取当前local
                let read = window.localStorage.getItem('read');
                // console.log(read.length);
                if (read == null || !(read.length > 2)) {
                    var _this = this;
                    return new Promise((resolve, reject) => {
                        _this.$axios({
                            method: 'get',// post
                            url: '/merge/download/?doc_id=' + doc_id,
                            data: '',
                            responseType: 'blob'
                        }).then((response) => {
                            // console.log(response)
                            const blob = new Blob([response.data]);
                            let fileName = _this.tableData.file_name;
                            if ('download' in document.createElement('a')) { // 非IE下载
                                const elink = document.createElement('a');
                                elink.download = fileName;
                                elink.style.display = 'none';
                                elink.href = window.URL.createObjectURL(blob);
                                document.body.appendChild(elink);
                                elink.click();
                                window.URL.revokeObjectURL(elink.href);// 释放URL 对象
                                document.body.removeChild(elink)
                            } else { // IE10+下载
                                navigator.msSaveBlob(blob, fileName)
                            }
                            resolve(response);
                        }).catch((err) => {
                            // reject(err)
                            console.log(err)
                        })
                    })
                } else {
                    this.$message({
                        message: '您还有段落未保存!',
                        type: 'warning',
                        duration: 1000,
                    });
                }

            },
            // 3秒跳转页面
            threeGo() {
                const TIME_COUNT = 3;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.show = false;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                            //跳转的页面写在此处
                            window.location.href = '/html/'
                            // this.$router.push({
                            //     path: baseURL() + '/'
                            // });
                        }
                    }, 1000)
                }
            },
            saveall() {
                let read = JSON.parse(localStorage.getItem('read'));
                let param = new FormData();
                param.append("row_data", JSON.stringify(read));
                var _this = this;
                _this.$axios.post('/merge/all_correct/', param)
                    .then(function (response) {
                        if(response.data.code == 0){
                            _this.$notify({
                                title: '一键保存成功',
                                message: '一键保存全部成功!!',
                                type: 'success',
                                duration: 1000,
                            });
                            // 通过key删除value
                            // 保存剩下的到local
                            window.localStorage.removeItem('read');
                            let rows = response.data.data.rows;
                            rows.forEach(i =>{
                                let status = $("tr:eq(" + (parseInt(i)+1) + ")").children().eq(2);
                                status.html("<i id='save_status' class='el-icon-success'></i>");
                            })
                        }
                    })
            },

            /*
                1. 保证每次传输来的数据数量一致，若不一致，插入空行。
                2. 在原文和译文长度均<=0的时候，停止加载数据。
                分页数据 push到数组最后
             */
            // 获取文档数据（分页）
            getDocData(){
                if(this.loading){
                    this.loading = false;
                    let doc_id = this.$route.query.doc_id;
                    this.$axios.get(`/merge/?doc_id=${doc_id}&limit=${this.limit}&offset=${this.offset*this.limit}`)
                        .then(res=>{
                            if(res.data.source.length > 0 && res.data.translate.length > 0) {
                                // 第一次时干的
                                if(JSON.stringify(this.tableData) == "{}"){
                                    // 存储到历史记录
                                    var data = {'file_name': res.data.file_name, 'doc_id': doc_id};
                                    localStorage.setItem('lately', JSON.stringify(data));
                                    // 首先， 数据赋值到data中
                                    this.tableData = res.data;
                                    // 其次，获取长度
                                    this.tLength = res.data.translate.length;
                                    this.sLength = res.data.source.length;
                                    // 最后， 补空位
                                    if (this.tLength > this.sLength) {
                                        // 译文比原文多了几段
                                        let lengthCut = this.tLength - this.sLength;
                                        // 循环依据
                                        // this.tableLoop = res.data.translate;
                                        this.tableLoopStatus = 1;
                                        let i = 0;
                                        let obj = this.tableData.source;
                                        while (i < lengthCut) {
                                            let p = new Object();
                                            p.source_p_id = this.tLength + i;
                                            p.uniqueid = this.tLength + i;
                                            p.is_para = true;
                                            p.source_p = "";
                                            obj.push(p)
                                            i++;
                                        }
                                    } else {
                                        // 原文比译文多了几段
                                        let lengthCut = this.sLength - this.tLength;
                                        // 循环依据
                                        // this.tableLoop = res.data.source;
                                        this.tableLoopStatus = 0;
                                        let i = 0;
                                        let obj = this.tableData.translate;
                                        while (i < lengthCut) {
                                            let p = new Object();
                                            p.source_p_id = this.tLength + i;
                                            p.uniqueid = this.tLength + i;
                                            p.is_para = true;
                                            p.source_p = "";
                                            obj.push(p)
                                            i++;
                                        }
                                    }
                                }else {
                                    // 首先， 数据赋值到data中
                                    res.data.source.forEach(item=>{
                                        this.tableData.source = this.tableData.source.concat(item);
                                    })

                                    res.data.translate.forEach(item=>{
                                        this.tableData.translate = this.tableData.translate.concat(item);
                                    })


                                    // 其次，获取长度
                                    this.tLength = this.tableData.translate.length;
                                    this.sLength = this.tableData.source.length;
                                    // 最后， 补空位
                                    if (this.tLength > this.sLength) {
                                        // 译文比原文多了几段
                                        let lengthCut = this.tLength - this.sLength;
                                        // 循环依据
                                        // this.tableLoop = this.tableData.translate;

                                        let i = 0;
                                        let obj = this.tableData.source;
                                        while (i < lengthCut) {
                                            let p = new Object();
                                            p.source_p_id = this.tLength + i;
                                            p.uniqueid = this.tLength + i;
                                            p.is_para = true;
                                            p.source_p = "";
                                            obj.push(p)
                                            i++;
                                        }
                                    } else {
                                        // 原文比译文多了几段
                                        let lengthCut = this.sLength - this.tLength;
                                        // 循环依据
                                        // this.tableLoop = this.tableData.source;

                                        let i = 0;
                                        let obj = this.tableData.translate;
                                        while (i < lengthCut) {
                                            let p = new Object();
                                            p.source_p_id = this.tLength + i;
                                            p.uniqueid = this.tLength + i;
                                            p.is_para = true;
                                            p.source_p = "";
                                            obj.push(p)
                                            i++;
                                        }
                                    }
                                }


                                if(this.tableLoopStatus == 1){
                                    this.tableLoop = this.tableData.translate;
                                }
                                if(this.tableLoopStatus == 0){
                                    this.tableLoop = this.tableData.source;
                                }

                                this.offset += 1;
                                this.loading = true;
                            }
                        })
                        .catch(function (error) {
                            this.$message({message: '没找到这篇文档, 请先上传一份吧！', duration: 2900, type: 'error'})
                            this.threeGo();
                        })
                }
            },
            // 节流throttle代码（定时器）：
            throttle(func, delay) {
                var timer = null;
                return function() {
                    var context = this;
                    var args = arguments;
                    if (!timer) {
                        timer = setTimeout(function() {
                            func.apply(context, args);
                            timer = null;
                        }, delay);
                    }
                }
            },
            monitorHeight(){
                // 滚动距离
                let scrollTop = this.dom.scrollTop
                // 变量windowHeight是可视区的高度
                let windowHeight = this.dom.clientHeight || this.dom.clientHeight
                // 变量scrollHeight是滚动条的总高度
                let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight
                if (scrollTop + windowHeight + 100 >= scrollHeight) {
                    this.getDocData()
                }
            }

        },
        mounted() {
            window.localStorage.removeItem('read');
            // 提示刷新
            this.$notify({
                title: 'Tips:',
                message: '操作无响应或出错可尝试刷新页面后重试',
                position: 'bottom-right'
            });
            this.getDocData();

            this.dom =  this.$refs.table.bodyWrapper;
            this.dom.addEventListener("scroll", this.throttle(this.monitorHeight, 100));
        },
    }
</script>

<style src="../assets/css/detail.css" scoped>

</style>
